const Home = () => import(/* webpackChunkName: "home" */ '@/components/Home/Index')
const Follow = () => import(/* webpackChunkName: "Follow"*/ '@/components/Follow/Index')
const PrivacyPolicy = () => import(/* webpackChunkName: "PrivacyPolicy"*/ '@/components/PrivacyPolicy/Index')
const TermsOfUse = () => import(/* webpackChunkName: "TermsOfUse"*/ '@/components/TermsOfUse/Index')
const Login = () => import(/* webpackChunkName: "Login"*/ '@/components/Login/Index')
const ProfessionalLogin = () => import(/* webpackChunkName: "ProfessionalLogin"*/ '@/components/Login/components/ProfessionalLogin/Index')
const ProfessionalLoginHeader = () => import(/* webpackChunkName: "ProfessionalLoginHeader"*/ '@/components/Login/components/ProfessionalLogin/Header')
const ContractorLogin = () => import(/* webpackChunkName: "ContractorLogin"*/ '@/components/Login/components/ContractorLogin/Index')
const ContractorLoginHeader = () => import(/* webpackChunkName: "ContractorLoginHeader"*/ '@/components/Login/components/ContractorLogin/Header')
const Logout = () => import(/* webpackChunkName: "Logout"*/ '@/components/Logout/Index')
const PasswordRecovery = () => import(/* webpackChunkName: "PasswordRecovery"*/ '@/components/PasswordRecovery/Index')
const PasswordRecoveryHeader = () => import(/* webpackChunkName: "PasswordRecoveryHeader"*/ '@/components/PasswordRecovery/Header')
const PasswordReset = () => import(/* webpackChunkName: "PasswordReset"*/ '@/components/PasswordReset/Index')
const PasswordResetHeader = () => import(/* webpackChunkName: "PasswordResetHeader"*/ '@/components/PasswordReset/Header')
const Register = () => import(/* webpackChunkName: "Register"*/ '@/components/Register/Index')
const AccountActivation = () => import(/* webpackChunkName: "Register"*/ '@/components/AccountActivation/Index')
const AccountActivationHeader = () => import(/* webpackChunkName: "Register"*/ '@/components/AccountActivation/Header')
const AccountDeletion = () => import(/* webpackChunkName: "Deletion"*/ '@/components/AccountDeletion/Index')
const AccountDeletionHeader = () => import(/* webpackChunkName: "Deletion"*/ '@/components/AccountDeletion/Header')
const ProfessionalPreRegister = () => import(/* webpackChunkName: "ProfessionalPreRegister"*/ '@/components/Register/components/ProfessionalPreRegister/Index')
const ProfessionalPreRegisterHeader = () => import(/* webpackChunkName: "ProfessionalPreRegisterHeader"*/ '@/components/Register/components/ProfessionalPreRegister/Header')
const ProfessionalRegister = () => import(/* webpackChunkName: "ProfessionalRegister"*/ '@/components/Register/components/ProfessionalRegister/Index')
const ProfessionalWorkProfiles = () => import(/* webpackChunkName: "ProfessionalWorkProfiles"*/ '@/components/Register/components/ProfessionalWorkProfiles/Index')
const ProfessionalRegisterHeader = () => import(/* webpackChunkName: "ProfessionalRegisterHeader"*/ '@/components/Register/components/ProfessionalRegister/Header')
const ContractorPreRegister = () => import(/* webpackChunkName: "ContractorPreRegister"*/ '@/components/Register/components/ContractorPreRegister/Index')
const ContractorPreRegisterHeader = () => import(/* webpackChunkName: "ContractorPreRegisterHeader"*/ '@/components/Register/components/ContractorPreRegister/Header')
const ContractorRegister = () => import(/* webpackChunkName: "ContractorRegister"*/ '@/components/Register/components/ContractorRegister/Index')
const ContractorRegisterHeader = () => import(/* webpackChunkName: "ContractorRegisterHeader"*/ '@/components/Register/components/ContractorRegister/Header')
const Account = () => import(/* webpackChunkName: "Account"*/ '@/components/Account/Index')
const ProfessionalAccount = () => import(/* webpackChunkName: "ProfessionalAccount"*/ '@/components/Account/components/ProfessionalAccount/Index')
const ProfessionalAccountHeader = () => import(/* webpackChunkName: "ProfessionalAccountHeader"*/ '@/components/Account/components/ProfessionalAccount/Header')
const AccountHome = () => import(/* webpackChunkName: "AccountHome"*/ '@/components/Account/components/ProfessionalAccount/components/Home/Index')
const Calendar = () => import(/* webpackChunkName: "Calendar"*/ '@/components/Account/components/ProfessionalAccount/components/Calendar/Index')
const Jobs = () => import(/* webpackChunkName: "Jobs"*/ '@/components/Account/components/ProfessionalAccount/components/Jobs/Index')
const Invites = () => import(/* webpackChunkName: "Invites"*/ '@/components/Account/components/ProfessionalAccount/components/Jobs/components/Invites/Index')
const JobDetails = () => import(/* webpackChunkName: "JobDetails"*/ '@/components/Account/components/ProfessionalAccount/components/Jobs/components/JobDetails/Index')
const JobHistory = () => import(/* webpackChunkName: "JobHistory"*/ '@/components/Account/components/ProfessionalAccount/components/Jobs/components/JobHistory/Index')

const ContractorAccount = () => import(/* webpackChunkName: "ContractorAccount"*/ '@/components/Account/components/ContractorAccount/Index')
const ContractorAccountHeader = () => import(/* webpackChunkName: "ContractorAccountHeader"*/ '@/components/Account/components/ContractorAccount/Header')
const ContractorAccountHome = () => import(/* webpackChunkName: "ContractorAccountHome"*/ '@/components/Account/components/ContractorAccount/components/Home/Index')
const ContractorAgenda = () => import(/* webpackChunkName: "ContractorAgenda"*/ '@/components/Account/components/ContractorAccount/components/Agenda/Index')
const ContractorCalendar = () => import(/* webpackChunkName: "ContractorCalendar"*/ '@/components/Account/components/ContractorAccount/components/Agenda/components/Calendar/Index')
const ContractorEventList = () => import(/* webpackChunkName: "ContractorEventList"*/ '@/components/Account/components/ContractorAccount/components/Agenda/components/List/Index')

const JobForm = () => import(/* webpackChunkName: "JobForm"*/ '@/components/Account/components/ContractorAccount/components/JobForm/Index')
const ContractorJobHistory = () => import(/* webpackChunkName: "ContractorJobHistory"*/ '@/components/Account/components/ContractorAccount/components/JobHistory/Index')
const ContractorEventSurvey = () => import(/* webpackChunkName: "ContractorEventSurvey"*/ '@/components/Account/components/ContractorAccount/components/EventSurvey/Index')
const EventCheckout = () => import(/* webpackChunkName: "EventCheckout"*/ '@/components/Account/components/ContractorAccount/components/EventCheckout/Index')
const EventDetails = () => import(/* webpackChunkName: "EventDetails"*/ '@/components/Account/components/ContractorAccount/components/EventDetails/Index')
const ContractorAgendaDay = () => import(/* webpackChunkName: "ContractorAgendaDay"*/ '@/components/Account/components/ContractorAccount/components/Agenda/components/Day/Index')

const ProfessionalFinder = () => import(/* webpackChunkName: "ProfessionalFinder"*/ '@/components/Account/components/ContractorAccount/components/ProfessionalFinder/Index')
const ProfessionalFinderProfile = () => import(/* webpackChunkName: "ProfessionalFinderProfile"*/ '@/components/Account/components/ContractorAccount/components/ProfessionalFinder/components/Profile/Index')

const CastSearch = () => import(/* webpackChunkName: "CastSearch"*/ '@/components/Account/components/ContractorAccount/components/CastSearch/Index')
const CastSearchProfile = () => import(/* webpackChunkName: "CastSearchProfile"*/ '@/components/Account/components/ContractorAccount/components/CastSearch/components/Profile/Index')

const FavoriteWorkProfiles = () => import(/* webpackChunkName: "CastSearchProfile"*/ '@/components/Account/components/ContractorAccount/components/FavoriteWorkProfiles/Index')

const Wallet = () => import(/* webpackChunkName: "Wallet"*/ '@/components/Account/components/Wallet/Index')

const ProfileShare = () => import(/* webpackChunkName: "ProfileShare"*/ '@/components/ProfileShare/Index')
const DynamicHeader = () => import(/* webpackChunkName: "DynamicHeader"*/ '@/components/Account/components/DynamicHeader/Index')

const ProfessionalAgendaDay = () => import(/* webpackChunkName: "ProfessionalAgendaDay"*/ '@/components/Account/components/ProfessionalAccount/components/Agenda/components/Day/Index')

import VueRouter from 'vue-router'

import goTo from 'vuetify/es5/services/goto'


const routes = [
    {
        path: '/',
        component: Home,
        name: 'Home',
        meta: {
            private: false,
            noHeader: true,
            institutional: true
        },
    },
    {
        path: '/follow',
        component: Follow,
        name: 'Follow',
        meta: {
            private: false,
            noHeader: true,
            institutional: true
        },
    },
    {
        path: '/privacy_policy',
        component: PrivacyPolicy,
        name: 'PrivacyPolicy',
        meta: {
            noHeader: true
        }
    },
    {
        path: '/terms_of_use',
        component: TermsOfUse,
        name: 'TermsOfUse',
        meta: {
            noHeader: true
        }
    },
    {
        path: '/login',
        component: Login,
        meta: {
            private: false
        },
        children: [
            {
                path: 'professional',
                component: ProfessionalLogin,
                name: 'ProfessionalLogin',
                meta: {
                    private: false,
                    header: ProfessionalLoginHeader
                }
            },
            {
                path: 'contractor',
                component: ContractorLogin,
                name: 'ContractorLogin',
                meta: {
                    private: false,
                    header: ContractorLoginHeader
                }
            }
        ]
    },
    {
        path: '/logout',
        component: Logout,
        name: 'Logout',
        meta: {
            private: true
        }
    },
    {
        path: '/contractor/password_recovery',
        component: PasswordRecovery,
        name: 'ContractorPasswordRecovery',
        meta: {
            type: 'contractor',
            header: PasswordRecoveryHeader
        }
    },
    {
        path: '/contractor/password_reset/:token',
        component: PasswordReset,
        name: 'ContractorPasswordReset',
        meta: {
            type: 'contractor',
            header: PasswordResetHeader
        }
    },
    {
        path: '/professional/password_recovery',
        component: PasswordRecovery,
        name: 'ProfessionalPasswordRecovery',
        meta: {
            type: 'professional',
            header: PasswordRecoveryHeader
        }
    },
    {
        path: '/professional/password_reset/:token',
        component: PasswordReset,
        name: 'ProfessionalPasswordReset',
        meta: {
            type: 'professional',
            header: PasswordResetHeader
        }
    },
    {
        path: '/contractor/:id/account_activation/:token',
        component: AccountActivation,
        name: 'ContractorAccountActivation',
        meta: {
            type: 'contractor',
            header: AccountActivationHeader
        }
    },
    {
        path: '/professional/:id/account_activation/:token',
        component: AccountActivation,
        name: 'ProfessionalAccountActivation',
        meta: {
            type: 'professional',
            header: AccountActivationHeader
        }
    },
    {
      path: '/deletion/:key',
      component: AccountDeletion,
      name: 'AccountDeletionStatus',
      meta: {
        header: AccountDeletionHeader
      }
    },
    {
        path: '/register',
        component: Register,
        children: [
            {
                name: 'ProfessionalPreRegister',
                path: 'professional/step/1',
                component: ProfessionalPreRegister,
                meta: {
                    private: false,
                    slimHeader: true,
                    header: ProfessionalPreRegisterHeader
                }
            },
            {
                name: 'ProfessionalActivation',
                path: 'professional/activation',
                component: AccountActivation,
                meta: {
                    type: 'professional',
                    header: ProfessionalPreRegisterHeader
                }
            },
            {
                path: 'professional/step/2',
                component: ProfessionalRegister,
                name: 'ProfessionalRegister',
                meta: {
                    private: true,
                    slimHeader: true,
                    header: ProfessionalRegisterHeader
                }
            },
            {
                path: 'professional/step/3',
                component: ProfessionalWorkProfiles,
                name: 'ProfessionalWorkProfiles',
                meta: {
                    private: true,
                    slimHeader: true,
                    header: ProfessionalRegisterHeader
                }
            },
            {
                name: 'ContractorPreRegister',
                path: 'contractor/step/1',
                component: ContractorPreRegister,
                meta: {
                    private: false,
                    slimHeader: true,
                    header: ContractorPreRegisterHeader
                }
            },
            {
                name: 'ContractorActivation',
                path: 'contractor/activation',
                component: AccountActivation,
                meta: {
                    type: 'contractor',
                    header: ContractorPreRegisterHeader
                }
            },
            {
                path: 'contractor/step/2',
                component: ContractorRegister,
                name: 'ContractorRegister',
                meta: {
                    private: true,
                    slimHeader: true,
                    header: ContractorRegisterHeader
                }
            }
        ]
    },
    {
        path: '/account',
        component: Account,
        meta: {
            private: true
        },
        children: [
            {
                path: 'professional',
                component: ProfessionalAccount,
                meta: {
                    header: ProfessionalAccountHeader,
                    slimHeader: true,
                    private: true
                },
                children: [
                    {
                        path: 'home',
                        component: AccountHome,
                        name: 'ProfessionalAccountHome',
                        meta: {
                            header: ProfessionalAccountHeader,
                            slimHeader: true,
                            private: true,
                            hash: '#account-header'
                        }
                    },
                    {
                        path: 'profile',
                        component: ProfessionalRegister,
                        name: 'ProfessionalProfile',
                        meta: {
                            header: ProfessionalAccountHeader,
                            slimHeader: true,
                            private: true
                        }
                    },
                    {
                        path: 'agenda',
                        component: Calendar,
                        name: 'ProfessionalAccountAgenda',
                        meta: {
                            header: ProfessionalAccountHeader,
                            slimHeader: true,
                            private: true
                        }
                    },
                    {
                        path: 'agenda/day/:day',
                        component: ProfessionalAgendaDay,
                        name: 'ProfessionalAgendaDay',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ProfessionalAccountHeader
                        }
                    },
                    {
                        path: 'jobs',
                        component: Jobs,
                        meta: {
                            private: true
                        },
                        children: [
                            {
                                path: 'invites',
                                component: Invites,
                                name: 'ProfessionalAccountInvites',
                                meta: {
                                    header: ProfessionalAccountHeader,
                                    slimHeader: true,
                                    private: true
                                }
                            },
                            {
                                path: 'details/:id/:messages?',
                                component: JobDetails,
                                name: 'JobDetails',
                                meta: {
                                    header: ProfessionalAccountHeader,
                                    slimHeader: true,
                                    private: true
                                }
                            },
                            {
                                path: 'history',
                                component: JobHistory,
                                name: 'JobHistory',
                                meta: {
                                    header: ProfessionalAccountHeader,
                                    slimHeader: true,
                                    private: true
                                }
                            }
                        ]
                    },
                    {
                        path: 'wallet',
                        component: Wallet,
                        name: 'ProfessionalWallet',
                        props: {
                            view: 'professional'
                        },
                        meta: {
                            header: ProfessionalAccountHeader,
                            slimHeader: true,
                            private: true
                        }
                    }
                ]
            },
            {
                path: 'contractor',
                component: ContractorAccount,
                meta: {
                    private: true,
                    slimHeader: true,
                    header: ContractorAccountHeader
                },
                children: [
                    {
                        path: 'profile',
                        component: ContractorRegister,
                        name: 'ContractorProfile',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'home',
                        component: ContractorAccountHome,
                        name: 'ContractorAccountHome',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader,
                            hash: '#account-header'
                        }
                    },
                    {
                        path: 'agenda',
                        component: ContractorAgenda,
                        name: 'ContractorAccountAgenda',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        },
                        children: [
                            {
                                path: 'calendar',
                                component: ContractorCalendar,
                                name: 'ContractorAccountCalendar',
                                meta: {
                                    private: true,
                                    slimHeader: true,
                                    header: ContractorAccountHeader
                                }
                            },
                            {
                                path: 'list',
                                component: ContractorEventList,
                                name: 'ContractorEventList',
                                meta: {
                                    private: true,
                                    slimHeader: true,
                                    header: ContractorAccountHeader
                                }
                            }
                        ]
                    },
                    {
                        path: 'create_job/professional_finder/:replaceJob?/:ignoreUser?/:currentIndex?',
                        component: ProfessionalFinder,
                        name: 'ProfessionalFinder',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'create_job/:id?',
                        component: JobForm,
                        name: 'ContractorJobForm',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'create_job/details/:id',
                        component: JobForm,
                        name: 'ContractorEventForm',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'create_job/details/:id/clone',
                        component: JobForm,
                        name: 'ContractorCloneEventForm',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'history',
                        component: ContractorJobHistory,
                        name: 'ContractorJobHistory',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'history/survey/:id',
                        component: ContractorEventSurvey,
                        name: 'ContractorEventSurvey',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'create_job/event/:id/checkout',
                        component: EventCheckout,
                        name: 'EventCheckout',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'agenda/details/:id/:messages?',
                        component: EventDetails,
                        name: 'EventDetails',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'agenda/day/:day',
                        component: ContractorAgendaDay,
                        name: 'ContractorAgendaDay',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'agenda/event/:replaceJob?/:ignoreUser?',
                        component: ProfessionalFinder,
                        name: 'ProfessionalReplace',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'agenda/event/replace/:id/:replaceJob?',
                        component: ProfessionalFinderProfile,
                        name: 'ProfessionalReplaceProfile',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'create_job/profile/:id/:replaceJob?',
                        component: ProfessionalFinderProfile,
                        name: 'ProfessionalFinderProfile',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'cast',
                        component: CastSearch,
                        name: 'CastSearch',
                        props: true,
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'cast/profile/:id',
                        component: CastSearchProfile,
                        name: 'CastSearchProfile',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'favorites',
                        component: FavoriteWorkProfiles,
                        name: 'FavoriteWorkProfiles',
                        meta: {
                            private: true,
                            slimHeader: true,
                            header: ContractorAccountHeader
                        }
                    },
                    {
                        path: 'wallet',
                        component: Wallet,
                        name: 'ContractorWallet',
                        props: {
                            view: 'contractor'
                        },
                        meta: {
                            header: ContractorAccountHeader,
                            slimHeader: true,
                            private: true
                        }
                    }
                ]
            },
            {
                path: '/profile/:id',
                component: ProfileShare,
                name: ProfileShare,
                meta: {
                    header: DynamicHeader,
                    slimHeader: true,
                    private: true
                }
            }
        ]
    }
]

const router = new VueRouter({
    routes,
    scrollBehavior(to) {
        let scrollTo = '#main-content'

        window.setTimeout(() => {
            if (to.meta?.hash) {
                scrollTo = to.meta.hash
            }
            if (to.hash) {
                scrollTo = to.hash
            }

            goTo(scrollTo, {
                easing: 'linear',
                duration: 0
            })
        }, 100)
    }
})

export default router
